<template>
  <div class="cpt-share-header">
    <div
      class="hb-share-header"
      @click="download"
      :style="{ opacity: opacity }"
      :class="{ 'use-in-share': useInShare }"
    >
      <div class="app-logo">
        <img :src="logoImg || client[clientType].img" />
      </div>
      <div class="col col-2">
        <div class="app-name">{{ title || client[clientType].title }}</div>
        <div class="app-desc">{{ desc || client[clientType].desc }}</div>
      </div>
      <div class="download-btn" :class="{ 'gradient-ramp': useInShare }">
        {{ useInShare ? '打开看看' : '立即下载' }}
      </div>
    </div>
    <div class="hb-qrc" v-if="clientType == 'heybox'">
      <img src="https://cdn.max-c.com/heybox/heybox_qrc_280.png" />
      <div class="main-txt">扫码下载小黑盒APP</div>
      <div class="sub-txt">发现游戏 分享快乐</div>
    </div>
  </div>
</template>

<script>
import { utils } from '_lib/utils';

export default {
  components: {},
  props: {
    desc: String,
    pageKey: String,
    shareConfig: Object,
    weixindata: Object,
    logoImg: String,
    opacity: {
      type: String,
      default: '0.9',
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    clientType: {
      type: String,
      default: 'heybox',
    },
    useInShare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageType: 'share',
      client: {
        heybox: {
          img: 'https://cdn.max-c.com/heybox/logo/app_251.png',
          title: '小黑盒',
          desc: '高能玩家聚集地',
          pageKey: 'share',
        },
        heybox_concept: {
          img: 'https://imgheybox.max-c.com/oa/2022/04/22/16a033ba9c4b74665c0a2a6266375afc.png',
          title: '小黑盒概念版',
          desc: '高能玩家聚集地',
          pageKey: 'concept_share',
        },
        maxjia: {
          img: 'https://imgheybox.max-c.com/oa/2022/06/20/4e6b70c4ed65ad194ff6da044874cdb7.png',
          title: 'MAX+',
          desc: '55%电竞玩家的第一选择',
          pageKey: 'max_share',
        },
      },
    };
  },
  watch: {
    shareConfig: {
      immediate: true,
      handler: function () {
        if (this.shareConfig) {
          utils.wxShare(this.weixindata || {}, this.shareConfig);
        }
      },
    },
  },
  methods: {
    report() {
      const BASE_URL =
        window.location.host.indexOf('localhost') >= 0
          ? ''
          : window.location.host.indexOf('debugmode.cn') >= 0
            ? 'https://heybox.debugmode.cn'
            : 'https://api.xiaoheihe.cn';
      this.pageType = this.pageKey || this.client[this.clientType].pageKey;
      const pageVisitImage = new Image();
      pageVisitImage.src =
      BASE_URL + '/game/upload_share_page_click/?source=' + this.pageType;
    },
    download() {
      window.location = 'https://api.xiaoheihe.cn/heybox/' + this.pageType;
    },
  },
  created() {
    if (!this.noPadding) {
      document.querySelector('body').classList.add('share');
    }
    this.report();
  },
};
</script>

<style lang="less">
body.share {
  padding-top: 60px !important;
  box-sizing: border-box;
}
body.open-app {
  padding-bottom: 106px;
}
.cpt-share-header {
  .hb-share-header {
    &::after {
      content: '';
      width: 200%;
      height: 1px;
      position: absolute;
      bottom: 0px;
      background: #f3f4f5;
      transform-origin: -40px bottom;
      transform: scale(0.5);
    }
    max-width: 640px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 4000;
    height: 60px;
    // background: rgba(255, 255, 255, .95);
    background: rgba(255, 255, 255, 1);
    padding: 10px 20px;
    // box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
    .app-logo {
      width: 40px;
      img {
        display: block;
        width: 40px;
        height: 40px;
        border-radius: 11px;
      }
    }
    > .col-2 {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      flex: 1;
      min-width: 0;
      padding: 0 10px;
      line-height: 1;
      font-weight: 400;
    }
    .app-name {
      font-size: 14px;
      line-height: 20px;
      color: #14191e;
    }
    .app-desc {
      font-size: 11px;
      line-height: 16px;
      color: #8c9196;
    }
    .download-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 72px;
      height: 30px;
      background: linear-gradient(46deg, #464B50 -0.9%, #14191E 100.9%);
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      border-radius: 3px;
      padding: 5px;
    }
    .gradient-ramp {
      background: linear-gradient(45deg, #464b50 0%, #14191e 100%);
    }
  }
  @media screen and (max-width: 980px) {
    .hb-qrc {
      display: none;
    }
  }
  .hb-qrc {
    width: 150px;
    position: fixed;
    z-index: 100;
    top: 148px;
    left: 50%;
    -webkit-transform: translateX(320px);
    transform: translateX(320px);
    font-size: 12px;
    line-height: 1;
    font-weight: 500;
    padding: 12px;
    background-color: #fff;
    img {
      display: block;
      width: 126px;
      height: 126px;
      margin: auto;
      margin-bottom: 8px;
    }
    .main-txt {
      font-size: 14px;
      font-weight: 500;
      color: #8c9196;
      text-align: center;
      line-height: 1;
      margin-bottom: 8px;
    }
    .sub-txt {
      color: #c8cdd2;
      font-size: 12px;
      text-align: center;
    }
  }

  @media only screen and (max-width: 640px) {
    .hb-share-header {
      &::after {
        transform-origin: -20px bottom;
      }
      padding: 10px 14px;
    }
  }

  .open-in-app {
    position: fixed;
    z-index: 2018;
    left: 0;
    right: 0;
    bottom: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 34px;
    background: #14191e;
    border-radius: 17px;
    box-shadow: 0 10px 16px 0 rgba(20, 25, 30, 0.14);
    color: #fff;
    font-size: 12px;
    line-height: 1;
    margin: auto;
  }
  .use-in-share {
    padding: 10px 14px;
    height: 60px;
  }
}
</style>
